import { useEffect, useState } from 'react'
import { getOnlineList } from '../../actions/online'
import { getOnlineAllocatorAttendeeDefaultColumns } from '../../utils/columns'
import ContextTable from '../ContextTable'

const OnlineAttendeeAllocators = () => {
  const [refreshData, setRefreshData] = useState(false)
  const [columns, setColumns] = useState(null)
  const [category, setCategory] = useState('allocator')

  const refresh = () => {
    setRefreshData(!refreshData)
  }

  useEffect(() => {
    const cols = getOnlineAllocatorAttendeeDefaultColumns(refresh)

    // getOnlineSortFilters(CATEGORY_ALLOCATOR)
    //   .then((res) => {
    //     var query = res.data;

    //     if (!isNil(query.sorter) && !isNil(query.sorter.columnKey)) {
    //       var sortIndex = cols.findIndex(
    //         (x) =>
    //           x.dataIndex === query.sorter.columnKey ||
    //           x.key === query.sorter.columnKey
    //       );
    //       if (sortIndex >= 0) {
    //         cols[sortIndex].defaultSortOrder = query.sorter.order;
    //       }
    //     }

    //     if (!isNil(query.filters) && !isNil(query.filters.columns)) {
    //       var filterIndex;

    //       for (let i = 0; i < query.filters.columns.length; i++) {
    //         filterIndex = cols.findIndex(
    //           (x) =>
    //             x.dataIndex === query.filters.columns[i].column ||
    //             x.key === query.filters.columns[i].column
    //         );

    //         if (filterIndex >= 0) {
    //           cols[filterIndex].defaultFilteredValue =
    //             query.filters.columns[i].values;
    //         }
    //       }
    //     }

    setColumns(cols)
    //   })
    //   .catch((err) => setColumns(cols));
  }, [refreshData])

  return (
    <>
      {columns && (
        <ContextTable
          tableTitle="Allocators"
          columns={columns}
          //eventId={eventId}
          dataMethod={(pagination, filters, sorter, searchTerm) =>
            getOnlineList(category, pagination, filters, sorter, searchTerm)
          } //savedQueryMethod={getSavedQuery}
          refresh={refreshData}
          refreshData={refreshData}
        />
      )}
    </>
  )
}

OnlineAttendeeAllocators.propTypes = {
  //eventId: PropTypes.number.isRequired,
}
export default OnlineAttendeeAllocators
